import { merge, timer, EMPTY } from 'rxjs';
import { map, debounceTime, throttleTime, switchMapTo, catchError, tap, skip } from 'rxjs/operators';
import { Map } from 'immutable';
import { renewSessionToken$, checkForUserInteraction$, notifyTokenExpiration$ } from './intents';
import createRequest$ from './request';
import { flog, distinctUntilChanged } from '@zambezi/caballo-vivo';
var tokenTimeoutWarning = 60 * 1000 * 4;
var expirationTimeRefresh$ = function expirationTimeRefresh$() {
  var refreshEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ping';
  return merge(renewSessionToken$, checkForUserInteraction$.pipe(map(function (snapshot) {
    return snapshot.get('location', Map());
  }), distinctUntilChanged, debounceTime(2000))).pipe(throttleTime(60 * 1000), switchMapTo(createRequest$(refreshEndpoint).pipe(catchError(function (e) {
    if (e.type === 'token-expired') throw e;
    return EMPTY;
  }), flog("Heartbeat sent"), switchMapTo(timer(tokenTimeoutWarning).pipe(tap(function () {
    return notifyTokenExpiration$.next();
  }), skip(1))))));
};
export default expirationTimeRefresh$;